/*
 *   File : list.js
 *   Author : https://evoqins.com
 *   Description : Send mail list page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import parse from 'html-react-parser';

//Custom components
import { CustomTab, EmptyScreen, Loader, Pagination } from '../../Components/Others';
import { useLocation, useNavigate } from 'react-router-dom';
import { PrimaryButton, SecondaryButton, TextButton } from '../../Components/Buttons';
import { CustomDataTable } from '../../Components/DataTable';
import { ViewTemplateModal } from '../../Components/Modal';
import { APIService } from '../../Service';

const TAB_TITLES = [
    { id: 1, label: 'Templates' },
    { id: 2, label: 'History' }
];

const DATA = [
    {
        title: "Upcoming SIP",
        description: "Customers investedJust a heads-up! Your next SIP is scheduled in 3 days. Make sure your account is funded to continue your investment seamlessly. "
    },
    {
        title: "KYC Completed Successfully!",
        description: "Congratulations! Your KYC has been successfully verified, and your investment account is now active. You’re all set to explore and invest in a variety of options tailored to your financial goals."
    },
    {
        title: "Upcoming SIP",
        description: "Customers investedJust a heads-up! Your next SIP is scheduled in 3 days. Make sure your account is funded to continue your investment seamlessly. "
    },
    {
        title: "Upcoming SIP",
        description: "Customers investedJust a heads-up! Your next SIP is scheduled in 3 days. Make sure your account is funded to continue your investment seamlessly. "
    },
    {
        title: "Upcoming SIP",
        description: " your account is funded to continue your investment seamlessly. "
    },
    {
        title: "Upcoming SIP",
        description: "Customers investedJust a heads-up! Your next SIP is scheduled in 3 days. Make sure your account is funded to continue your investment seamlessly. "
    },
];

const TABLE_DATA = [
    {
        title: "Upcoming SIP",
        users: "All users",
        no_of_users: "12345",
        date: "15 Apr 2025     11:10 am"
    },
    {
        title: "Mandate failing",
        users: "Invested users",
        no_of_users: "12345",
        date: "15 Apr 2025     11:10 am"
    },
    {
        title: "Upcoming SIP",
        users: "Non-invested users",
        no_of_users: "12345",
        date: "15 Apr 2025     11:10 am"
    },
    {
        title: "Upcoming SIP",
        users: "All users",
        no_of_users: "12345",
        date: "15 Apr 2025     11:10 am"
    },
    {
        title: "Upcoming SIP",
        users: "All users",
        no_of_users: "12345",
        date: "15 Apr 2025     11:10 am"
    },
    {
        title: "Upcoming SIP",
        users: "All users",
        no_of_users: "12345",
        date: "15 Apr 2025     11:10 am"
    },
    {
        title: "Upcoming SIP",
        users: "All users",
        no_of_users: "12345",
        date: "15 Apr 2025     11:10 am"
    },
];

const ITEMS_PER_PAGE = 12;

const SendMail = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const scrollRef = useRef(null);

    const [tabIndex, setTabIndex] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const [tableCurrentPage, setTableCurrentPage] = useState(1);

    const [templateList, setTemplateList] = useState({});
    const [loader, setLoader] = useState(true);

    const [viewTemplateModal, setViewTemplateModal] = useState(false);
    const [viewData, setViewData] = useState({});


    useEffect(() => {
        _templateList();
    }, [currentPage]);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (viewTemplateModal === true) {
            const modal = new Modal(document.getElementById("view-template-modal"));
            modal.show();
        }
    }, [viewTemplateModal]);

    useEffect(() => {
        if (state !== null) {
            if (state.tab_index) {
                setTabIndex(state.tab_index);

                setCurrentPage(1);
                setTableCurrentPage(1);
            } else {
                setTabIndex(1);
            }
        } else {
            setTabIndex(1);
        }
    }, [state]);

    // handle tab
    const _handleTab = (tab_id) => {
        navigate("/send-mail", {
            state: {
                tab_index: tab_id
            }
        });
    };

    // handle pagination
    const _handlePagination = (new_start_limit) => {
        const selected_page = Math.floor(new_start_limit / ITEMS_PER_PAGE) + 1;
        setCurrentPage(selected_page);

        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    };

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        // _orderList(page_num);
        setTableCurrentPage(page_num);

        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: "smooth", block: 'start' })
        }
    };

    // handle manage template         
    const _handleAddTemplate = () => {
        navigate(`manage-template`);
    };

    // handle edit template 
    const _handleEdit = (data) => {
        navigate(`manage-template`, {
            state: {
                edit: true,
                edit_data: data
            }
        });
    };

    // handle manage mail 
    const _handleManageMail = (type, data) => {
        if (type === 1) {
            navigate("manage-mail", {
                state: {
                    edit: false
                }
            });
        } else {
            navigate("manage-mail", {
                state: {
                    edit: true,
                    data: data
                }
            });
        }
    };

    // handle view template 
    const _handleView = (data) => {
        setViewTemplateModal(true);
        setViewData(data);
    };

    const TABLE_COLUMN = [

        {
            name: 'Email title',
            selector: row => row.title ? row.title : row.subject,
            cell: row => <>{row.title ? row.title : row.subject}</>,
            width: "280px",
            sortable: true
        },

        {
            name: 'Target users',
            selector: row => row.target_users,
            width: "200px",
            sortable: true,
        },
        {
            name: 'No of users',
            selector: row => row.total_users,
            width: "140px",
            sortable: true
        },
        {
            name: 'Triggered by',
            selector: row => row.name || "-",
            cell: row => <>{row.name || "-"}</>,
            width: "180px"
        },
        {
            name: 'Send date & time',
            selector: row => row.created,
            width: "220px"
        },
        {
            name: "",
            cell: (row) =>
                <TextButton name="View"
                    className='e-hover'
                    onClick={() => _handleView(row)} />
        }
    ];

    // API - Template lis
    const _templateList = () => {
        let is_post = true;
        let url = 'send-email/list-templates';
        let request = {
            "page_num": currentPage,
            "page_size": ITEMS_PER_PAGE
        }
        // setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setTemplateList(response.data);

                setTotalPageCount(response.data.total_page);
            } else {
                setTemplateList({ data: [] });
            }
            setLoader(false);
        });
    };

    const [historyData, setHistoryData] = useState({});
    const [historyLoader, setHistoryLoader] = useState(true);

    useEffect(() => {
        if (tabIndex === 2) {
            _emailHistory();
        }
    }, [tabIndex, tableCurrentPage]);

    // API - send email history
    const _emailHistory = () => {
        let is_post = true;
        let url = 'send-email/history';
        let request = {
            "page_num": tableCurrentPage,
            "page_size": ITEMS_PER_PAGE
        }
        // setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setHistoryData(response.data);

                // setTotalPageCount(response.data.total_page);
            } else {
                setHistoryData({ data: [] });
            }
            setHistoryLoader(false);
        });
    };
    // useEffect(() => {

    //     if (loader === false) {
    //         console.log("templateList?.data[0]", templateList?.data[0]);

    //     }
    // }, [loader]);

    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <h3 className='mb-0 e-text-chinese-black e-primary-font e-font-24 e-font-weight-600 line-height-24px'>
                        Send Mail
                    </h3>
                </div>

                <div className='padding-52px-lr margin--80px-top'>
                    <div ref={scrollRef} className={`${tabIndex === 1 ? "padding-32px-all" : " padding-32px-tb"} e-bg-white border-radius-16  `}>
                        <div className={`${tabIndex === 2 ? "padding-32px-lr" : ""} d-flex align-items-center justify-content-start pb-4 gap-3`}>
                            <CustomTab data={TAB_TITLES}
                                selectedTab={tabIndex}
                                handleClick={_handleTab} />
                        </div>

                        {tabIndex === 1 ?
                            <>
                                <div className=' d-flex align-items-center justify-content-between gap-3 flex-wrap'>
                                    <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                        Templates list
                                    </h4>
                                    <div className='d-flex align-items-center gap-3'>
                                        <SecondaryButton name='Add Template'
                                            className="e-text-smoky-black"
                                            paddingBlock='padding-12px-tb padding-32px-lr'
                                            onClick={_handleAddTemplate} />
                                        <PrimaryButton name='Send mail'
                                            paddingBlock='padding-12px-tb padding-40px-lr'
                                            onClick={() => _handleManageMail(1)} />
                                    </div>
                                </div>

                                {loader ?
                                    <Loader className="min-vh-75" />
                                    :
                                    templateList.data.length !== 0 ?
                                        <div className='row row-gap-4 pt-4'>
                                            {templateList.data.map((data, index) => (
                                                <div key={index} className='col-lg-4 col-6'>
                                                    <div className='border-radius-8 e-bg-magnolia overflow-hidden d-flex flex-column h-100 justify-content-between'>
                                                        <div>
                                                            <div style={{ height: "280px" }}>
                                                                {data.image &&
                                                                    <img src={data.image}
                                                                        draggable={false}
                                                                        height={280}
                                                                        className='w-100 h- object-fit-contain'
                                                                        alt='template' />
                                                                }
                                                            </div>

                                                            <div className='px-3 pt-3'>
                                                                <div className='pb-1 d-flex align-items-center gap-3 justify-content-between'>
                                                                    <p className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                                        {data.title}
                                                                    </p>

                                                                    <TextButton name="Edit"
                                                                        onClick={() => _handleEdit(data)} />
                                                                </div>

                                                                {/* <p className='my-2 py-1 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px truncate-four-line'>
                                                                    {data.content}
                                                                </p> */}

                                                                <div className='truncate-second-line e-html-parser-data'>
                                                                    {parse(data.content)}
                                                                </div>


                                                            </div>
                                                        </div>


                                                        <div className=' px-3 pt-2 pb-3'>
                                                            <p className='mb-0 e-text-smoky-black e-primary-font e-font-14 e-font-weight-400 line-height-20px'>
                                                                <span className='e-font-weight-600'>Timestamp:</span> {data.updated || "-"}
                                                            </p>
                                                            <div className='d-flex align-items-center gap-3  pt-2 justify-content-between'>
                                                                <TextButton name="View"
                                                                    onClick={() => _handleView(data)} />
                                                                <PrimaryButton name="Send mail"
                                                                    className="p-1 border-radius-4 rounded-1"
                                                                    onClick={() => _handleManageMail(2, data)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        :
                                        <EmptyScreen
                                            image={require('../../Assets/Image/NotFound/no-data.png')}
                                            title='No results found'
                                        />

                                }

                                {templateList?.total_page > 1 &&
                                    <div className='pt-4 mt-3'>
                                        <Pagination itemsPerPage={ITEMS_PER_PAGE}
                                            totalPage={totalPageCount}
                                            currentPage={currentPage}
                                            forcePage={currentPage - 1}

                                            totalItems={templateList.total_count}

                                            showFirstLastPages={true}
                                            pageRangeDisplayed={0}
                                            marginPagesDisplayed={0}
                                            onChange={_handlePagination} />
                                    </div>
                                }


                                {/* {loader === false &&
                                    <>
                                        {parse(templateList?.data[0]?.html)}
                                    </>
                                } */}
                            </>
                            :
                            tabIndex === 2 ?
                                <>
                                    {historyLoader === true ?
                                        <Loader className="min-vh-75" />
                                        :
                                        historyData.data.length !== 0 ?

                                            <div className='e-data-table-wrapper-default-updated pt-3'>
                                                <CustomDataTable columns={TABLE_COLUMN}
                                                    data={historyData.data}
                                                    pagination={true}
                                                    lastPage={historyData.total_page}
                                                    paginationPerPage={ITEMS_PER_PAGE}
                                                    paginationDefaultPage={historyData.current_page}
                                                    paginationTotalRows={historyData.total_count}
                                                    onChangePage={_handleTablePageChange}
                                                />
                                            </div>
                                            :
                                            <EmptyScreen image={require('../../Assets/Image/NotFound/no-data.png')}
                                                title='No results found' />
                                    }
                                </>
                                :
                                null
                        }
                    </div>
                </div>
            </section>

            {viewTemplateModal === true &&
                <ViewTemplateModal data={viewData}
                    handleClose={() => {
                        setTimeout(() => {
                            setViewTemplateModal(false);
                        }, 200);
                    }} />
            }
        </Fragment>
    )
}

export default SendMail;
